
import { defineComponent, onMounted, reactive } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ApiService from "@/core/services/ApiService";

import { useToast } from "vue-toastification";
import { ref } from "yup";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    Loading,
  },
  props: {
    widgetClasses: String,
  },

  data() {
    return {
      tableData: [],
      paging: {
        page: 0,
        totalPages: 0,
        size: 10,
        totalElements: 0,
        perPageOptions: [10, 25, 50, 100],
      },

      name: "",
      isLoading: false,
      fullPage: true,
      isColor: "#007BFF",
      isBackgroundColor: "#A3A3A3",
      isOpacity: 0.5,
    };
  },

  beforeMount() {
    store.dispatch(Actions.VERIFY_AUTH_BANK);

    this.getData(this.paging.size, this.paging.page);

    setCurrentPageBreadcrumbs("Bank Pusat", ["Data"]);
  },

  computed: {
    to() {
      let highBound = this.from + this.paging.size;
      if (this.paging.totalElements < highBound) {
        highBound = this.paging.totalElements;
      }
      return highBound;
    },
    from() {
      return this.paging.size * this.paging.page;
    },
  },

  methods: {
    getData(size, page) {
      console.log("getdata");
      this.isLoading = true;
      let search = "";
      if (this.name) {
        search = "name=" + this.name + "&";
      } else {
        search;
      }
      ApiService.getWithData(
        `crmv2/order/product/admin/all?${search}page=${page}&limit=${size}&sort=createTime&dir=-1`,
        {}
      )
        .then(({ data }) => {
          console.log(data);
          this.isLoading = false;
          this.tableData = data.content;
          this.paging.page = data.page;
          this.paging.size = data.size;
          this.paging.totalElements = data.totalElements;
          this.paging.totalPages = data.totalPages;
        })
        .catch(({ response }) => {
          this.isLoading = false;
        });
    },

    handleDelete(index, item) {
      Swal.fire({
        title: "Apakah Anda Yakin ?",
        text: `Data yang telah dihapus tidak dapat dikembalikan !`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Ya, hapus !",
        cancelButtonText: "Batal",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(item);
        }
      });
    },
    deleteRow(item) {
      this.isLoading = true;
      const toast = useToast();
      ApiService.delete("crmv2/product/admin/" + item._id)
        .then((res) => {
          this.isLoading = false;
          toast.success("Hapus Berhasil");
          this.getData(this.paging.size, this.paging.page);
        })
        .catch((error) => {
          this.isLoading = false;
          toast.error("Gagal Hapus");
        });
    },

    range(min, max) {
      const arr: any[] = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },

    changePage(item) {
      const page = item - 1;
      this.getData(this.paging.size, page);
    },
    nextPage() {
      const page = this.paging.page + 1;
      this.getData(this.paging.size, page);
    },
    prevPage() {
      const page = this.paging.page - 1;
      this.getData(this.paging.size, page);
    },
    changePageSize(e) {
      const page = this.paging.page;
      this.getData(this.paging.size, page);
    },
  },
});
